__turbopack_context__.v({
  "statItem": "component-module__fvv1VW__statItem",
});
